
export default function IconLink() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="linkopen"
      width="20px"
      height="20px"
    >
      <g>
        <path d="M6,19.75H4A1.75213,1.75213,0,0,1,2.25,18V3A1.75213,1.75213,0,0,1,4,1.25H17A1.75213,1.75213,0,0,1,18.75,3V5a.75.75,0,0,1-1.5,0V3A.253.253,0,0,0,17,2.75H4A.253.253,0,0,0,3.75,3V18a.253.253,0,0,0,.25.25H6a.75.75,0,0,1,0,1.5Z"></path>
        <path d="M20,22.75H7A1.75213,1.75213,0,0,1,5.25,21V6A1.75213,1.75213,0,0,1,7,4.25H20A1.75213,1.75213,0,0,1,21.75,6V21A1.75213,1.75213,0,0,1,20,22.75ZM7,5.75A.25048.25048,0,0,0,6.75,6V21a.25048.25048,0,0,0,.25.25H20a.25048.25048,0,0,0,.25-.25V6A.25048.25048,0,0,0,20,5.75Z"></path>
      </g>
    </svg>
  );
}
